import api from './api';
import {
  clearFinanceUnlockToken,
  setFinanceUnlockToken,
} from './financeLockSession';

export async function getFinanceLockStatus() {
  const { data } = await api.get('/finance-lock/status');
  return data;
}

export async function enableFinanceLock(pin) {
  const payload = pin ? { pin } : {};
  const { data } = await api.post('/finance-lock/enable', payload);
  return data;
}

export async function disableFinanceLock() {
  const { data } = await api.post('/finance-lock/disable');
  clearFinanceUnlockToken();
  return data;
}

export async function changeFinancePin(pin) {
  const { data } = await api.post('/finance-lock/change-pin', { pin });
  return data;
}

export async function unlockFinance(pin) {
  const { data } = await api.post('/finance-lock/unlock', { pin });

  if (data?.unlockToken) {
    setFinanceUnlockToken(data.unlockToken);
  }

  return data;
}

export async function lockFinance() {
  const { data } = await api.post('/finance-lock/lock');
  clearFinanceUnlockToken();
  return data;
}
